import { ActiveRpt, CallDetailsInfo, ReportRowDataType } from './Types'

export class ReportRowData implements ReportRowDataType {
    public rowID: string = ''
    public isRealTime: boolean = false
    public deviceCallCtrlFlags: number = 0
    public callCtrlFlags: number = 0
    public telSysID: string = ''
    public partitionID: string = ''
    public deviceID: string = ''
    public agentID?: string
    public isActiveReport: boolean = false
    public deviceCallIDActive: string = ''
    public callIDTelSysTarget: string = ''
    public enableNonUserEndpointActions: boolean = false
    public isDNDAndACDNAShown: boolean = false
    public callID: string = ''
    public activeReport: ActiveRpt = {}
    public groupsFilter: string[] = []
    public updateState = (): void => {
        // eslint-disable-next-line
        console.debug('Update state was not initialised.')
    }
    public reportRefresh = (): void => {
        // eslint-disable-next-line
        console.debug('Failed to initialise refreshing of report data.')
    }

    public reportType?: number
    public isSearchInfoIDMain?: boolean
    public isSearchInfoIDAlt?: boolean
    public isSearchInfoIDItem?: boolean
    public isCallActive?: boolean
    public currentUserMode?: boolean
    public callDetails?: CallDetailsInfo

    public constructor(reportRowData?: ReportRowDataType) {
        if (reportRowData) {
            const {
                rowID,
                reportType,
                telSysID,
                partitionID,
                deviceID,
                agentID,
                callID,
                deviceCallIDActive,
                callIDTelSysTarget,
                callCtrlFlags,
                deviceCallCtrlFlags,
                isActiveReport,
                isRealTime,
                enableNonUserEndpointActions,
                isDNDAndACDNAShown,
                isSearchInfoIDMain,
                isSearchInfoIDAlt,
                isSearchInfoIDItem,
                isCallActive,
                activeReport,
                groupsFilter,
                callDetails,
                updateState
            }: ReportRowDataType = reportRowData

            this.rowID = rowID ?? this.rowID
            this.reportType = reportType ?? this.reportType
            this.telSysID = telSysID ?? this.telSysID
            this.partitionID = partitionID ?? this.partitionID
            this.deviceID = deviceID ?? this.deviceID
            this.agentID = agentID ?? this.agentID
            this.callID = callID ?? this.callID
            this.deviceCallIDActive = deviceCallIDActive ?? this.deviceCallIDActive
            this.callIDTelSysTarget = callIDTelSysTarget ?? this.callIDTelSysTarget
            this.callCtrlFlags = callCtrlFlags ?? this.callCtrlFlags
            this.deviceCallCtrlFlags = deviceCallCtrlFlags ?? this.deviceCallCtrlFlags
            this.isActiveReport = isActiveReport ?? this.isActiveReport
            this.isRealTime = isRealTime ?? this.isRealTime
            this.enableNonUserEndpointActions = enableNonUserEndpointActions ?? this.enableNonUserEndpointActions
            this.isDNDAndACDNAShown = isDNDAndACDNAShown ?? this.isDNDAndACDNAShown
            this.isSearchInfoIDMain = isSearchInfoIDMain ?? this.isSearchInfoIDMain
            this.isSearchInfoIDAlt = isSearchInfoIDAlt ?? this.isSearchInfoIDAlt
            this.isSearchInfoIDItem = isSearchInfoIDItem ?? this.isSearchInfoIDItem
            this.isCallActive = isCallActive ?? this.isCallActive
            this.activeReport = activeReport ?? this.activeReport
            this.groupsFilter = groupsFilter ?? this.groupsFilter
            this.callDetails = callDetails ?? this.callDetails
            this.updateState = updateState ?? this.updateState
        }
    }

    public static newInstance(reportRowData?: ReportRowDataType): ReportRowData {
        return new ReportRowData(reportRowData)
    }
}
